import { render, staticRenderFns } from "./InvoiceTemplatePdfPreview.vue?vue&type=template&id=81c43130&"
import script from "./InvoiceTemplatePdfPreview.vue?vue&type=script&lang=js&"
export * from "./InvoiceTemplatePdfPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports